import React, { PureComponent } from 'react';

import styles from './styles.less';
import Icon from '~/UI/Icon';

interface Props {
	style: any;
}

export default class Header extends PureComponent<Props> {
	static defaultProps = {
		style: null,
	};

	render() {
		const { style } = this.props;

		return (
			<div className={styles.header} style={style}>
				<div className={styles.addOrRemoveCell} />
				<div className={styles.countryCell}>Country</div>
				<div className={styles.brandCell}>Brand name</div>
				<div className={styles.mahCell}>Company</div>
				<div className={styles.dosageCell}>Dosage Form</div>
				<div className={styles.dosageStrengthCell}>Dosage strength</div>
				<div className={styles.packageCell}>Package</div>
				<div className={styles.referencePriceCell}>
					Price
					<span
						className={styles.parameterIcon}
						title={`Spodní cena (zvýrazněná tučně): Původní cena zveřejněná ve zdroji (Ex-factory price, nebo cena sloužící pro přepočet na Ex-factory price)\nHorní cena: Ex-factory price (zveřejněná, nebo vypočítaná dle SP-CAU-010)`}
					>
						<Icon name='violet-question-mark' />
					</span>
				</div>
				<div className={styles.packageForCalculationCell}>Package for calc.</div>
				<div
					className={styles.priceCell}
					title={`Calc. price: Cena vzniklá vynásobením ceny (pole Price) velikostí balení (pole Package for calc.)\nSpodní cena (zvýrazněná tučně): Původní cena zveřejněná ve zdroji (Ex-factory price, nebo cena sloužící pro přepočet na Ex-factory price)\nHorní cena: Ex-factory price (zveřejněná, nebo vypočítaná dle SP-CAU-010)`}
				>
					Calc. Price
					<span className={styles.parameterIcon}>
						<Icon name='violet-question-mark' />
					</span>
				</div>
				<div className={styles.selectionCell}>Use for calc.</div>
				<div className={styles.usedForCalculationCell} />
			</div>
		);
	}
}
